<template lang="pug">
  div
    v-container
      v-row(justify="center")
        v-col(
          cols="12"
          md="11"
        )
          v-row.mx-0
            v-btn(
              text
              @click.stop="$router.push({ name: 'scholars' })"
            ).plain.pl-0
              v-icon(
                color="primary"
              ) mdi-chevron-left 
              h2 Back to List
            v-spacer
            v-btn(
              :color="publishBtn.color"
              :loading="publishLoading"
              @click.stop="publish"
            ).plain {{ publishBtn.text }}
      v-row(justify="center")
        v-col(
          cols="12"
          md="11"
        )
          v-card(flat)
            v-row(justify="center").mx-0.py-4
              v-col(
                cols="4"
                sm="4"
                md="3"
              )
                v-tooltip(bottom)
                  template(#activator="{ on }")
                    img-cropper(
                      ref="imgCropperRef"
                      @done="cropped"
                      force-crop
                      :aspect-ratio="3/2"
                    )
                      template(slot="picker")
                        a(
                          v-on="on"
                          @click.stop="$refs.imgCropperRef.selectFile()"
                        )
                          v-card.pa-1
                            v-img(
                              :src="picURL"
                              :aspect-ratio="3/2"
                            )
                  span Upload Photo
              v-col(
                cols="12"
                sm="8"
                md="9"
              )
                p.font-24 {{ fullName }}
                  v-btn(
                    icon 
                    color="primary"
                    @click.stop="showUpdateDetailsDialog = true"
                  )
                    v-icon mdi-pencil
                v-row
                  v-col(
                    cols="12" 
                    md="2"
                  )
                    span.font-16.font-weight-bold Ambition: 
                  v-col(
                    cols="12" 
                    md="10"
                  )
                    span.font-16 {{ ambition }}
                v-row
                  v-col(
                    cols="12" 
                    md="2"
                  )
                    span.font-16.font-weight-bold Story: 
                  v-col(
                    cols="12" 
                    md="10"
                  )
                    pre(wrap) {{ storyShort }}
                v-row
                  v-col(
                    cols="12" 
                    md="2"
                  )
                    span.font-16.font-weight-bold Bio:
                  v-col(
                    cols="12" 
                    md="10"
                  )
                    pre(wrap) {{ storyLong }}
              v-col(cols="12").mt-12
                scholar-detail-funding(
                  :beneficiary="beneficiary"
                  :fundings="fundings"
                )
              v-col(cols="12").mt-12
                scholar-detail-timeline(
                  :beneficiary="beneficiary"
                  :timelines="timelines"
                )
    scholar-update-details-dialog(
      :beneficiary="beneficiary"
      :showDialog="showUpdateDetailsDialog"
      @submit="detailsUpdated"
      @cancel="showUpdateDetailsDialog = false"
    )
</template>

<script>
import placeholderImg from '@/assets/avatar-placeholder.png';
import ScholarUpdateDetailsDialog from '@/components/scholar/ScholarUpdateDetailsDialog';
import ScholarDetailTimeline from '@/components/scholar/ScholarDetailTimeline';
import ScholarDetailFunding from '@/components/scholar/ScholarDetailFunding';
import _ from 'lodash';
import ImgCropper from '../components/commons/img-cropper';
import { firebaseStorage } from '../plugins/firebase';

export default {
  components: {
    ImgCropper,
    ScholarUpdateDetailsDialog,
    ScholarDetailTimeline,
    ScholarDetailFunding
  },
  data () {
    return {
      beneficiary: { name: {} },
      placeholderImg,
      publishLoading: false,
      showUpdateDetailsDialog: false,
      fundings: [],
      timelines: [],
      publishBtn: {}
    };
  },
  computed: {
    picURL () {
      const beneficiary = this.beneficiary || {};
      return beneficiary.picURL || placeholderImg;
    },
    name () {
      const beneficiary = this.beneficiary || {};
      return beneficiary.name || {};
    },
    firstName () {
      const beneficiary = this.beneficiary || {};
      const name = beneficiary.name || {};
      return name.firstName || '';
    },
    lastName () {
      const beneficiary = this.beneficiary || {};
      const name = beneficiary.name || {};
      return name.lastName || '';
    },
    fullName () {
      return `${this.lastName}, ${this.firstName}`;
    },
    ambition () {
      const beneficiary = this.beneficiary || {};
      return beneficiary.ambition || '';
    },
    storyShort () {
      const beneficiary = this.beneficiary || {};
      return beneficiary.storyShort || '';
    },
    storyLong () {
      const beneficiary = this.beneficiary || {};
      return beneficiary.storyLong || '';
    }
  },
  beforeMount () {
    this.init();
  },
  methods: {
    async init () {
      try {
        this.$setLoading(true);
        this.beneficiary = await this.$store.dispatch('beneficiaries/getById', {
          id: this.$route.params.scholarId
        });
        const beneficiary = this.beneficiary || {};

        const timelines = await this.$store.dispatch(
          'timeline/get',
          {
            beneficiary: beneficiary.id
          }
        );
        console.log('init#beneficiary: %0', this.beneficiary);

        this.timelines = _.sortBy(timelines, ['date']).reverse();

        this.fundings = await this.$store.dispatch(
          'fundings/get',
          {
            beneficiary: beneficiary.id
          }
        );

        if (this.beneficiary.published) {
          this.publishBtn = {
            text: 'Unpublish',
            color: 'error'
          };
        } else {
          this.publishBtn = {
            text: 'Publish',
            color: 'primary'
          };
        }
      } catch (err) {
        this.$enqueueSnack(err);
      } finally {
        this.$setLoading(false);
      }
    },
    async publish () {
      try {
        this.$setLoading(true);
        this.publishLoading = true;

        if (this.beneficiary.published) {
          await this.$store.dispatch('beneficiaries/update', {
            id: this.beneficiary.id,
            $publish: !this.beneficiary.published
          });
          await this.$store.dispatch(
            'fundings/resolve',
            {
              id: this.beneficiary.activeFunding,
              beneficiary: this.beneficiary.id,
              $resolve: true
            }
          );
        } else {
          await this.$store.dispatch('beneficiaries/update', {
            id: this.beneficiary.id,
            $publish: !this.beneficiary.published
          });
        }
        this.$enqueueSnack(`Successfully ${!this.beneficiary.published ? 'published' : 'unpublished'} scholar`);
      } catch (err) {
        this.$enqueueSnack(err);
      } finally {
        this.$setLoading(false);
        this.publishLoading = false;
        this.$router.push({ name: 'scholars' });
      }
    },
    async cropped (img) {
      this.$setLoading(true);
      try {
        const storageRef = firebaseStorage.ref();
        const ref = storageRef.child(`mightyminds/beneficiaries/${this.beneficiary.id}/avatar.jpg`);
        await ref.putString(img, 'data_url');
        const picURL = await ref.getDownloadURL();
        this.beneficiary = await this.$store.dispatch('beneficiaries/update', { picURL, id: this.beneficiary.id });
        this.$enqueueSnack('Profile updated');
      } catch (err) {
        this.$enqueueSnack(err);
      } finally {
        this.$setLoading(false);
      }
    },
    detailsUpdated (updatedBeneficiary) {
      this.beneficiary = updatedBeneficiary;
      this.showUpdateDetailsDialog = false;
    }
  }
};
</script>

<style scoped>
pre {
  font-family: Poppins !important;
}
</style>